var React = require('react');

function CreditCard2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("rect",{"height":"59.16","rx":"4","width":"93.95","x":"2","y":"2","key":0}),React.createElement("path",{"d":"m53.16 14.84h31.26","key":1}),React.createElement("path",{"d":"m74.56 38.28h9.86v9.86h-9.86z","key":2}),React.createElement("path",{"d":"m25.47 43.33h6.17","key":3}),React.createElement("path",{"d":"m37.81 43.33h6.16","key":4}),React.createElement("path",{"d":"m50.14 43.33h6.16","key":5}),React.createElement("path",{"d":"m13.14 43.33h6.16","key":6})]));
}

CreditCard2.defaultProps = {"viewBox":"0 0 97.95 63.16"};

module.exports = CreditCard2;

CreditCard2.default = CreditCard2;
